<template>
  <section class="section section-shaped section-lg my-0">
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <div class="text-center">
              <img class="w-100" style="max-width: 183px" :src="$baseUrl + 'img/brand/logo-1.png'">
            </div>
            <div class="mt-3"/>
            <div class="text-center text-muted mb-4">
              <small class="text-main-color">請選擇要處理的門市</small>
            </div>
            <div v-if="organizations.length === 0" class="text-center text-muted">載入中...</div>
            <div v-for="org in organizations" :key="org.id" class="mb-3">
              <base-button
                  class="w-100 font-size-16 org-option"
                  size="lg"
                  :type="isCurrent(org) ? 'main-color' : 'secondary'"
                  @click="choose(org)"
              >
                <i class="fa fa-building-o mr-2"></i>{{ orgLabel(org) }}
              </base-button>
            </div>
          </card>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SelectOrganizationView',
  computed: {
    organizations() {
      return this.$store.state.myOrganizations || [];
    },
  },
  async created() {
    // 重新整理或被後端拒絕後進來時，名單可能是空的或過期，重新向後端確認
    await this.$store.dispatch('initMyOrganization', {needLogin: true});
    const org = this.$store.state.myOrganization;
    // 只有一間門市，或上次選的仍有效且不是主動要切換：直接進入
    if (org && org.id && !this.$route.query.switch) {
      this.$router.replace('/');
    }
  },
  methods: {
    isCurrent(org) {
      const current = this.$store.state.myOrganization;
      return !!current && current.id === org.id;
    },
    orgLabel(org) {
      return org.store_name || org.name || ('門市 ' + org.id);
    },
    choose(org) {
      // 切換門市後整頁重載，頁面資料全部以新門市重新載入
      this.$store.dispatch('selectOrganization', {organization: org, reload: true});
    },
  },
};
</script>

<style scoped>
/* 門市名稱靠左對齊 */
.org-option {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
}
</style>
